export type InstallPromptEvent = Event & {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

export function standalone() {
  return window.matchMedia("(display-mode: standalone)").matches ||
    Boolean("standalone" in navigator && navigator.standalone);
}

export function applicationServerKey(value: string) {
  const padding = "=".repeat((4 - value.length % 4) % 4);
  const decoded = window.atob((value + padding).replace(/-/gu, "+").replace(/_/gu, "/"));
  return Uint8Array.from(decoded, (character) => character.charCodeAt(0));
}

export function isInstallPromptEvent(event: Event): event is InstallPromptEvent {
  return "prompt" in event && typeof event.prompt === "function" && "userChoice" in event &&
    typeof event.userChoice === "object" && event.userChoice !== null && "then" in event.userChoice && typeof event.userChoice.then === "function";
}
